import Component from './modal.vue';
export default Component;
